module.exports = __webpack_public_path__ + "files/4ca9d8e1fd3cb2ca4ea9da5bd41b7180.svg";